"use client";

import React, { useState } from "react";
import { useRouter, usePathname } from "next/navigation";
import Link from "next/link.js";
import Navigation from "./Navigation";
// import { Menu } from "antd";
import { menuData, getMenuId } from "./menu.js";
import s from "./index.module.scss";

const Main = (props) => {
  const router = useRouter();
  const pathname = usePathname();

  const initMenu = getMenuId(pathname, menuData) || "/";

  const [current, setCurrent] = useState(initMenu);

  const onClick = (e) => {
    setCurrent(e.key);

    router.push(`${e.item.props.path}`);
  };
  const newOpen = () => {
    window.open("/download", "_blank");
  };

  return (
    <div className={s.headerDiv}>
      <div className={s.headerDiv2}>
        <Link className={s.logo} href="/" />
        <div className={s.menu}>
          {/* <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={menuData} /> */}
      <Navigation />
          {/* <Menu
            items={menuData}
            onClick={onClick}
            selectedKeys={[current]}
            style={{ marginTop: "7px" }}
            mode="horizontal"
          /> */}
          <div className={s.download} onClick={newOpen}>
            下载APP
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
